import React, { Component } from 'react'
import './Card.scss'

export default class Card extends Component {
    render() {
        return (
            <div className='ic-card'>
                <div className="ic-card__image-container">
                    <img src={this.props.image || ''} alt="card-placeholder" />
                </div>
                <div className='ic-description'>
                    <h3>{this.props.title || ''}</h3>
                    <div className="ic-description__info">{this.props.content || ''}</div>
                </div>
            </div>
        )
    }
}
